// import React, { useEffect, useState } from "react";
// import { Download, FileText, Calendar, Filter } from "lucide-react";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { Api } from "../Api/Api";

// const Reports = () => {
//   const [data, setData] = useState({
//     customers: [],
//     payments: [],
//     expenses: [],
//   });
//   const [filter, setFilter] = useState("daily"); // daily, weekly, monthly, all
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadData();
//   }, []);

//   const loadData = async () => {
//     try {
    
//       const [c, p, e] = await Promise.all([
//         fetch(`${Api}customers/list.php`).then((r) => r.json()),
//         fetch(`${Api}payments/list.php`).then((r) => r.json()),
//         fetch(`${Api}expenses/list.php`).then((r) => r.json()),
//       ]);

//       setData({
//         customers: c.customers || [],
//         payments: p.payments || [],
//         expenses: e.expenses || [],
//       });
//     } catch (err) {
//       console.error("Error loading reports:", err);
//     }
//     setLoading(false);
//   };

//   /* DATE FILTER LOGIC */
//   const getFilteredPayments = () => {
//     const now = new Date();
//     return data.payments.filter((p) => {
//       const pDate = new Date(p.payment_date);
//       if (filter === "daily")
//         return pDate.toDateString() === now.toDateString();
//       if (filter === "weekly") {
//         const weekAgo = new Date();
//         weekAgo.setDate(now.getDate() - 7);
//         return pDate >= weekAgo;
//       }
//       if (filter === "monthly") {
//         return (
//           pDate.getMonth() === now.getMonth() &&
//           pDate.getFullYear() === now.getFullYear()
//         );
//       }
//       return true;
//     });
//   };

//   const filteredPayments = getFilteredPayments();
//   const totalPaid = filteredPayments.reduce(
//     (sum, p) => sum + Number(p.paid_amount),
//     0,
//   );

//   // Calculate Pending (Simplified logic based on your previous snippets)
//   const totalPending = data.customers.reduce((sum, c) => {
//     const start = new Date(c.given_date);
//     const weeks = Math.floor((new Date() - start) / (7 * 86400000)) || 0;
//     const shouldPay = weeks * Number(c.weekly_interest_amount);
//     const paid = data.payments
//       .filter((p) => Number(p.customer_id) === Number(c.id))
//       .reduce((s, p) => s + Number(p.paid_amount), 0);
//     return sum + Math.max(shouldPay - paid, 0);
//   }, 0);

//   /* PDF GENERATION */
//   const downloadPDF = () => {
//     const doc = new jsPDF();
//     const dateStr = new Date().toLocaleDateString();

//     // Header
//     doc.setFontSize(18);
//     doc.text("SRI MURUGAN TRADERS - Financial Report", 14, 20);
//     doc.setFontSize(10);
//     doc.text(`Report Type: ${filter.toUpperCase()} | Date: ${dateStr}`, 14, 28);

//     // Summary Table
//     doc.autoTable({
//       startY: 35,
//       head: [["Description", "Amount (INR)"]],
//       body: [
//         ["Total Collected (Paid)", `Rs. ${totalPaid.toLocaleString()}`],
//         ["Total Outstanding (Pending)", `Rs. ${totalPending.toLocaleString()}`],
//         [
//           "Total Active Customers",
//           data.customers.filter((c) => c.status === "Active").length,
//         ],
//       ],
//       theme: "striped",
//     });

//     // Detailed Payments Table
//     doc.text("Transaction Details:", 14, doc.lastAutoTable.finalY + 10);
//     const tableRows = filteredPayments.map((p, index) => [
//       index + 1,
//       p.payment_date,
//       p.customer_name || `ID: ${p.customer_id}`,
//       `W-${p.week_number}`,
//       p.paid_amount,
//     ]);

//     doc.autoTable({
//       startY: doc.lastAutoTable.finalY + 15,
//       head: [["S.No", "Date", "Customer", "Week", "Amount"]],
//       body: tableRows,
//     });

//     doc.save(`Report_${filter}_${dateStr}.pdf`);
//   };

//   if (loading)
//     return <div className="p-10 text-center">Loading Reports...</div>;

//   return (
//     <div className="min-h-screen bg-gray-50 p-6">
//       <div className="max-w-5xl mx-auto space-y-6">
//         <div className="flex justify-between items-center">
//           <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
//             <FileText className="text-indigo-600" /> Financial Reports
//           </h1>
//           <button
//             onClick={downloadPDF}
//             className="flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition"
//           >
//             <Download size={18} /> Download PDF
//           </button>
//         </div>

//         {/* FILTERS */}
//         <div className="bg-white p-4 rounded-xl shadow-sm border">
//           <div className="flex gap-3 overflow-x-auto pb-1 no-scrollbar">
//             {["daily", "weekly", "monthly", "all"].map((t) => (
//               <button
//                 key={t}
//                 onClick={() => setFilter(t)}
//                 className={`px-4 py-2 rounded-md text-sm font-bold capitalize whitespace-nowrap transition flex-shrink-0 ${
//                   filter === t
//                     ? "bg-indigo-600 text-white shadow-md"
//                     : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//                 }`}
//               >
//                 {t} Report
//               </button>
//             ))}
//           </div>
//         </div>
//         {/* SUMMARY CARDS */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//           <SummaryCard
//             title="Collection (Paid)"
//             value={totalPaid}
//             color="text-green-600"
//             bg="bg-green-50"
//           />
//           <SummaryCard
//             title="Outstanding (Pending)"
//             value={totalPending}
//             color="text-red-600"
//             bg="bg-red-50"
//           />
//           <SummaryCard
//             title="Net Transactions"
//             value={filteredPayments.length}
//             isCurrency={false}
//             color="text-blue-600"
//             bg="bg-blue-50"
//           />
//         </div>

//         {/* RECENT TRANSACTIONS TABLE */}
//         <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
//           <div className="p-4 border-b bg-gray-50">
//             <h2 className="font-bold text-gray-700">
//               Detailed Transactions ({filter})
//             </h2>
//           </div>
//           <table className="w-full text-sm text-left">
//             <thead className="bg-gray-100 text-gray-600 uppercase text-[10px] font-bold">
//               <tr>
//                 <th className="px-6 py-3">Date</th>
//                 <th className="px-6 py-3">Customer ID</th>
//                 <th className="px-6 py-3">Week No</th>
//                 <th className="px-6 py-3 text-right">Paid Amount</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y">
//               {filteredPayments.map((p) => (
//                 <tr key={p.id} className="hover:bg-gray-50">
//                   <td className="px-6 py-4 font-medium">{p.payment_date}</td>
//                   <td className="px-6 py-4">{p.customer_id}</td>
//                   <td className="px-6 py-4">Week {p.week_number}</td>
//                   <td className="px-6 py-4 text-right font-bold text-indigo-600">
//                     ₹{Number(p.paid_amount).toLocaleString()}
//                   </td>
//                 </tr>
//               ))}
//               {filteredPayments.length === 0 && (
//                 <tr>
//                   <td colSpan="4" className="text-center py-10 text-gray-400">
//                     No transactions found for this period.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// const SummaryCard = ({ title, value, color, bg, isCurrency = true }) => (
//   <div className={`${bg} p-6 rounded-2xl border border-white shadow-sm`}>
//     <p className="text-xs font-bold text-gray-500 uppercase tracking-wider">
//       {title}
//     </p>
//     <p className={`text-3xl font-black mt-2 ${color}`}>
//       {isCurrency ? `₹${value.toLocaleString()}` : value}
//     </p>
//   </div>
// );

// export default Reports;


import React, { useEffect, useMemo, useState } from "react";
import { Download, FileText } from "lucide-react";
import jsPDF from "jspdf";
// import "jspdf-autotable";
// import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Api } from "../Api/Api";

const Reports = () => {
  const [data, setData] = useState({
    customers: [],
    payments: [],
    expenses: [],
  });
  const [filter, setFilter] = useState("daily"); // daily | weekly | monthly | all
  const [loading, setLoading] = useState(true);

  /* LOAD DATA */
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [c, p, e] = await Promise.all([
        fetch(`${Api}customers/list.php`).then((r) => r.json()),
        fetch(`${Api}payments/list.php`).then((r) => r.json()),
        fetch(`${Api}expenses/list.php`).then((r) => r.json()),
      ]);

      setData({
        customers: c.customers || [],
        payments: p.payments || [],
        expenses: e.expenses || [],
      });
    } catch (err) {
      console.error("Error loading reports:", err);
    }
    setLoading(false);
  };

  /* CUSTOMER LOOKUP MAP */
  const customerMap = useMemo(() => {
    const map = {};
    data.customers.forEach((c) => {
      map[c.id] = {
        code: c.customer_code,
        name: c.name,
      };
    });
    return map;
  }, [data.customers]);

  /* FILTER PAYMENTS */
  const filteredPayments = useMemo(() => {
    const now = new Date();

    return data.payments.filter((p) => {
      const pDate = new Date(p.payment_date);

      if (filter === "daily")
        return pDate.toDateString() === now.toDateString();

      if (filter === "weekly") {
        const weekAgo = new Date();
        weekAgo.setDate(now.getDate() - 7);
        return pDate >= weekAgo;
      }

      if (filter === "monthly") {
        return (
          pDate.getMonth() === now.getMonth() &&
          pDate.getFullYear() === now.getFullYear()
        );
      }

      return true; // all
    });
  }, [filter, data.payments]);

  /* TOTALS */
  const totalPaid = filteredPayments.reduce(
    (sum, p) => sum + Number(p.paid_amount),
    0,
  );

  const totalPending = data.customers.reduce((sum, c) => {
    const start = new Date(c.given_date);
    const weeks = Math.floor((new Date() - start) / (7 * 86400000)) || 0;

    const shouldPay = weeks * Number(c.weekly_interest_amount);

    const paid = data.payments
      .filter((p) => Number(p.customer_id) === Number(c.id))
      .reduce((s, p) => s + Number(p.paid_amount), 0);

    return sum + Math.max(shouldPay - paid, 0);
  }, 0);


  const downloadPDF = () => {
    const doc = new jsPDF();
    const dateStr = new Date().toLocaleDateString();

    doc.setFontSize(18);
    doc.text("SRI AADHI LAKKSHMI - Financial Report", 14, 20);

    doc.setFontSize(10);
    doc.text(`Report Type: ${filter.toUpperCase()} | Date: ${dateStr}`, 14, 28);

    autoTable(doc, {
      startY: 35,
      head: [["Description", "Amount"]],
      body: [
        ["Total Collected (Paid)", `₹ ${totalPaid.toLocaleString()}`],
        ["Total Outstanding (Pending)", `₹ ${totalPending.toLocaleString()}`],
        [
          "Active Customers",
          data.customers.filter((c) => c.status === "Active").length,
        ],
      ],
      theme: "striped",
    });

    const tableRows = filteredPayments.map((p, index) => {
      const customer = customerMap[p.customer_id] || {};
      return [
        index + 1,
        p.payment_date,
        `${customer.code || "—"} - ${customer.name || "Unknown"}`,
        `W-${p.week_number}`,
        `₹ ${Number(p.paid_amount).toLocaleString()}`,
      ];
    });

    doc.text("Transaction Details", 14, doc.lastAutoTable.finalY + 10);

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 15,
      head: [["S.No", "Date", "Customer", "Week", "Amount"]],
      body: tableRows,
    });

    doc.save(`Report_${filter}_${dateStr}.pdf`);
  };

  const formatDateDMY = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};


  if (loading)
    return <div className="p-10 text-center">Loading Reports...</div>;

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* HEADER */}
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
            <FileText className="text-indigo-600" /> Financial Reports
          </h1>

          <button
            onClick={downloadPDF}
            className="flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700"
          >
            <Download size={18} /> Download PDF
          </button>
        </div>

        {/* FILTER */}
        <div className="bg-white p-4 rounded-xl border">
          <div className="flex gap-3 overflow-x-auto">
            {["daily", "weekly", "monthly", "all"].map((t) => (
              <button
                key={t}
                onClick={() => setFilter(t)}
                className={`px-4 py-2 rounded-md text-sm font-bold capitalize ${
                  filter === t
                    ? "bg-indigo-600 text-white"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
              >
                {t} report
              </button>
            ))}
          </div>
        </div>

        {/* SUMMARY */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <SummaryCard
            title="Collection (Paid)"
            value={totalPaid}
            color="text-green-600"
            bg="bg-green-50"
          />
          <SummaryCard
            title="Outstanding (Pending)"
            value={totalPending}
            color="text-red-600"
            bg="bg-red-50"
          />
          <SummaryCard
            title="Transactions"
            value={filteredPayments.length}
            isCurrency={false}
            color="text-blue-600"
            bg="bg-blue-50"
          />
        </div>

        {/* TABLE */}
        <div className="bg-white rounded-xl border overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-100 text-gray-600 uppercase text-[10px] font-bold">
              <tr>
                <th className="px-6 py-3">S.No</th>
                <th className="px-6 py-3">Date</th>
                <th className="px-6 py-3">Customer</th>
                <th className="px-6 py-3">Week</th>
                <th className="px-6 py-3 text-right">Amount</th>
              </tr>
            </thead>

            <tbody className="divide-y">
              {filteredPayments.map((p, index) => {
                const customer = customerMap[p.customer_id] || {};
                return (
                  <tr key={p.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-gray-400 font-mono">
                      {String(index + 1).padStart(2, "0")}
                    </td>

                    <td className="px-6 py-4"> {formatDateDMY(p.payment_date)}</td>

                    <td className="px-6 py-4">
                      <div className="font-bold text-indigo-700">
                        {customer.code || "—"}
                      </div>
                      <div className="text-xs text-gray-500">
                        {customer.name || "Unknown"}
                      </div>
                    </td>

                    <td className="px-6 py-4">Week {p.week_number}</td>

                    <td className="px-6 py-4 text-right font-bold text-indigo-600">
                      ₹{Number(p.paid_amount).toLocaleString()}
                    </td>
                  </tr>
                );
              })}

              {filteredPayments.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center py-10 text-gray-400">
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

/* SUMMARY CARD */
const SummaryCard = ({ title, value, color, bg, isCurrency = true }) => (
  <div className={`${bg} p-6 rounded-2xl shadow-sm`}>
    <p className="text-xs font-bold text-gray-500 uppercase">{title}</p>
    <p className={`text-3xl font-black mt-2 ${color}`}>
      {isCurrency ? `₹${value.toLocaleString()}` : value}
    </p>
  </div>
);

export default Reports;
